import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { ElderShellService } from '@elderbyte/ngx-starter'
import { Material } from '../material'
import { MaterialDetailComponent } from '../material-detail/material-detail.component'

@Component({
  selector: 'app-material-detail-side',
  templateUrl: './material-detail-side.component.html',
  styleUrls: ['./material-detail-side.component.scss'],
  imports: [MaterialDetailComponent],
})
export class MaterialDetailSideComponent {
  private route = inject(ActivatedRoute)
  private shellService = inject(ElderShellService)

  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  readonly material: Material

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    this.material = this.route.snapshot.data['material']!
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public onClose(event: Event): void {
    this.shellService.closeSideContent()
  }
}
